export const environment = {
	production: '$GC_ISPRODUCTION',
	authority: '$GC_AUTHORITY',
	clientId: '$GC_CLIENTID',
	scope: '$GC_SCOPE',
	gatewayUrl: '$GC_GWURL',
	fileBlobStorage: '$GC_BLOBSTORE',
	gormSignalRUrl: '$GC_GWSIGNALR',
	appInsightsInstrumentationKey: '$GC_AIINSTRUMENTATIONKEY',
	crmmigrationUrl: '$GC_CMURL',
	aiBuilderUrl: 'https://grouponline.app.n8n.cloud/form/e0294305-2157-4b15-ac57-44c076820247',
	environment: '$GC_ENVIRONMENT'
};
